import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface DialogDataInput {
  title: string;
  content: string;
  buttons: {
    text: string;
    cssClass?: string;
    focus?: boolean;
    closeDialogOnAction?: boolean;
    action: () => void;
  }[];
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
  ],
  selector: 'customer-dialog-data',
  templateUrl: './dialog-data.component.html',
  styleUrls: ['./dialog-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDataComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogDataInput) {}
}
